module.exports = __webpack_public_path__ + "img/Icon12-13.bc931758.svg";